<template>
  <div class="desktop-header ion-padding-horizontal">
    <div>
      <search-form v-if="isSearchAvailable"/>
    </div>
    <div class="group-button">
      <ion-button
        class="button"
        fill="clear"
        v-if="isSearchAvailable"
      >
        <ion-icon
          slot="icon-only"
          src="assets/icon/filter.svg"/>
      </ion-button>
      <ion-button
        v-if="isActiveSubscriber"
        class="button button__btn-notice"
        fill="clear"
        @click="navigateNotification"
      >
        <span v-if="hasUnreadEvents" class="button__btn-notice__badge" />
        <ion-icon
          slot="icon-only"
          src="assets/icon/notice.svg"
        />
      </ion-button>

      <ion-button
        class="user-profile__btn-notice "
        fill="clear"
        @click="onLogout"
      >
        <ion-icon
          slot="icon-only"
          src="assets/icon/log-out.svg"/>
      </ion-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
    IonIcon,
    IonButton
} from "@ionic/vue";
import SearchForm from "@/modules/General/components/SearchForm.vue";
import router from "@/router";
import {RouteNamesEnum} from "@/const/routes";
import { RegistrationProgress } from "@/gql/graphql";
import { computed } from "vue";
import { useUserStore } from "../store/userStore";
import { hasUnreadEvents } from "@/helpers/setUnreadEvents";
import { disableListeners } from "@/helpers/cordova-plugin-purchase";
import { isMobile } from "@/helpers/isMobile";

const user = computed(() => useUserStore()?.user);

const isActiveSubscriber = computed(() => user.value?.team?.is_active_subscriber || (user.value?.is_impersonated && (user.value?.registration_progress === RegistrationProgress.Completed || user.value?.registration_progress === RegistrationProgress.Admin)));
const onLogout = () => {
  router.push({ name: RouteNamesEnum.Logout });
  if(isMobile.value) {
    disableListeners();
  }
}
defineProps<{
  isSearchAvailable?: boolean;
}>();

const navigateNotification = () => {
  router.push({name: RouteNamesEnum.Notifications});
}
</script>

<style lang="scss" scoped>
.desktop-header {
  display: flex;
  justify-content: space-between;

  .button {
    height: auto;
    margin-left: 20px;
    --color: var(--ion-color-dark-grey);
    --padding-start: 0;
    --padding-top: 0;
    --padding-end: 0;
    --padding-bottom: 0;
    --background-hover: trasparent;

    &:hover {
      color: var(--ion-color-primary);
    }

    &__btn-notice {
      position: relative;
      --color: var(--ion-color-dark-grey);

      &__badge {
        position: absolute;
        right: 3px;
        top: 2px;
        width: 8px;
        height: 8px;
        background: var(--ion-color-cancelled);
        border-radius: 50%;
      }
    }
  }
}
</style>